const FilePlay = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_235_18702)">
        <path
          d="M19 1H5C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M9 8.80902C9 8.43733 9.39116 8.19558 9.72361 8.3618L16.1056 11.5528C16.4741 11.737 16.4741 12.263 16.1056 12.4472L9.72361 15.6382C9.39116 15.8044 9 15.5627 9 15.191V8.80902Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_235_18702">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FilePlay;
